var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"icons"},_vm._l((_vm.contactIcons),function(item,index,id){return _c('li',{key:id},[_c('a',{class:item.icon,attrs:{"href":item.link}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }